import { useTranslation } from 'react-i18next'

import {
  checkIsRemoveAttachMassAction,
  getRequestProfileTabAttachedRequestsMassActions,
} from '../../RequestProfileTabAttachedRequests.utils'

export function useRelatedRequestsTabTablePage({
  canEditRelatedRequests,
  isArchive,
  tablePage,
  onRemoveAttach,
}) {
  const { t } = useTranslation()

  const { permissions, selectedIds, setMassAction } = tablePage

  const massActions = getRequestProfileTabAttachedRequestsMassActions({
    canEditRelatedRequests,
    isArchive,
    permissions,
    t,
  })

  function handleSetMassAction(action) {
    if (checkIsRemoveAttachMassAction(action)) {
      onRemoveAttach(selectedIds)

      return
    }

    setMassAction(action)
  }

  return { ...tablePage, massActions, setMassAction: handleSetMassAction }
}
